import React from 'react';
import './App.css';
import Menu from './menu';
import InfiniteScroll from './InfiniteScroll';
import useScrollOpacity from './useScrollOpacity';




function App() {
  const fixedTextRef = useScrollOpacity(false, 250, 250);

  return (
    <div className="App">
      <div ref={fixedTextRef} className="fixed-text-container">
        <div>Direction Design and Research</div>
        <div>for Screens Stages and Spaces</div>
      </div>
      <Menu />
      <InfiniteScroll />

    </div>
  );


}

export default App;